<ham-modal
    [title]="'aumico_accounto_connect_modal_title' | i18next"
    [hideFooter]="true"
    [size]="'sm'"
    [hideCloseIcon]="step === 'testing'"
    [enableKeyboardShortcuts]="step !== 'testing'"
    (cancel)="onCancel()"
>
    <div class="accounto-modal-body">
        <!-- Step 1: form -->
        <section *ngIf="step === 'welcome'">
            <p class="accounto-modal-body__paragraph">
                {{ 'aumico_accounto_step_welcome_intro' | i18next }}
            </p>

            <div class="accounto-modal-body__field">
                <label for="accountoDisplayName">
                    {{ 'aumico_integration_setup_displayname_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="accountoDisplayName"
                    type="text"
                    [(ngModel)]="displayName"
                    [placeholder]="'aumico_integration_setup_displayname_placeholder' | i18next"
                />
                <small class="accounto-modal-body__hint">
                    {{ 'aumico_accounto_step_config_displayname_help' | i18next }}
                </small>
            </div>

            <!--
                The key is a real `type=password` input (the toggle flips it to `text`).
                `autocomplete="new-password"` keeps browsers from autofilling a stored
                login into it.
            -->
            <div class="accounto-modal-body__field">
                <label for="accountoApiKey">
                    {{ 'aumico_accounto_step_config_apikey_label' | i18next }}
                </label>
                <input
                    hamInput
                    id="accountoApiKey"
                    [type]="showApiKey ? 'text' : 'password'"
                    [(ngModel)]="apiKey"
                    autocomplete="new-password"
                    spellcheck="false"
                    data-lpignore="true"
                />
                <div class="accounto-modal-body__hint-row">
                    <small class="accounto-modal-body__hint">
                        {{ 'aumico_accounto_step_config_apikey_help' | i18next }}
                    </small>
                    <button
                        type="button"
                        class="accounto-modal-body__toggle"
                        (click)="onToggleApiKey()"
                    >
                        {{
                            showApiKey
                                ? ('aumico_accounto_step_config_apikey_hide' | i18next)
                                : ('aumico_accounto_step_config_apikey_show' | i18next)
                        }}
                    </button>
                </div>
                <small *ngIf="apiKeyInvalid" class="accounto-modal-body__invalid" role="alert">
                    {{ 'aumico_accounto_validation_apikey_invalid' | i18next }}
                </small>
            </div>

            <!-- A disabled Connect says why (guidelines §2.1): the required fields still empty. -->
            <p *ngIf="missingFieldLabelKeys.length > 0" class="accounto-modal-body__missing">
                {{ 'aumico_accounto_validation_missing_fields' | i18next }}
                <ng-container *ngFor="let labelKey of missingFieldLabelKeys; let last = last">
                    {{ labelKey | i18next }}{{ last ? '' : ',' }}
                </ng-container>
            </p>

            <div class="accounto-modal-body__actions">
                <ham-button
                    variant="primary"
                    size="sm"
                    [disabled]="!isFormValid"
                    (buttonClick)="onSubmit()"
                >
                    {{ 'aumico_integration_connect_button' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>

        <!--
            Step 2: BE testing the key. No way out here (no Cancel, close icon or Escape):
            the BE stores the connection anyway, and only an open flow auto-matches its tenants.
            The step ends with the BE's answer (success closes, failure shows the error step).
        -->
        <section *ngIf="step === 'testing'" class="accounto-modal-body__loading">
            <div class="accounto-modal-body__spinner"></div>
            <p class="accounto-modal-body__paragraph">
                {{ 'aumico_integration_status_testing' | i18next }}
            </p>
        </section>

        <!-- Step 3: error from the key test -->
        <section *ngIf="step === 'error'" class="accounto-modal-body__error">
            <lucide-icon
                name="triangle-alert"
                [size]="48"
                aria-hidden="true"
                class="accounto-modal-body__error-glyph"
            ></lucide-icon>
            <h3 class="accounto-modal-body__title">{{ 'aumico_integration_status_error_title' | i18next }}</h3>
            <p class="accounto-modal-body__error-message">{{ errorMessage }}</p>
            <div class="accounto-modal-body__actions">
                <ham-button variant="primary" size="sm" (buttonClick)="onRetryFromError()">
                    {{ 'aumico_button_retry' | i18next }}
                </ham-button>
                <ham-button variant="primary" size="sm" [outline]="true" (buttonClick)="onCancel()">
                    {{ 'aumico_button_cancel' | i18next }}
                </ham-button>
            </div>
        </section>
    </div>
</ham-modal>
